const useEventListener = options => {
  const {
    event = "click",
    callback = () => {},
    target = document,
    action = "add",
    useCapture = false
  } = options;

  let eventListener;
  switch (action) {
    case "add": eventListener = target.addEventListener; break;
    case "remove": eventListener = target.removeEventListener; break;
  }

  eventListener(event, callback, useCapture);
};

export default useEventListener;